import { color, backgroundColor, margins, paddings, textAlign, textTransform } from '@olist/styled-system';
import { css } from 'styled-components';

const renderTextVariations = (variation, type, bold, stylish) => {
    return css `
    font-optical-sizing: auto;
    font-size: ${variation[type].mobile.fontSize};
    line-height: ${variation[type].mobile.lineHeight};
    font-weight: ${variation[type].mobile.fontWeight};
    letter-spacing: ${variation[type].mobile.letterSpacing};
    font-family: ${variation[type].mobile.fontFamily};
    color: ${(props) => props.theme.olist.components.text.color};

    ${bold
        ? css `
          font-weight: ${(props) => props.theme.olist.components.text.bold};
        `
        : ''}

    ${stylish
        ? css `
          font-variant-ligatures: no-historical-ligatures;
          font-feature-settings: 'ss03';
        `
        : ''}

    @media (min-width: 768px) {
      font-size: ${variation[type].desktop.fontSize};
      line-height: ${variation[type].desktop.lineHeight};
      letter-spacing: ${variation[type].desktop.letterSpacing};
      font-family: ${variation[type].desktop.fontFamily};

      ${bold
        ? ''
        : css `
            font-weight: ${variation[type].desktop.fontWeight};
          `}
    }

    ${color}
    ${backgroundColor}
    ${margins}
    ${paddings}
    ${textAlign}
    ${textTransform}
  `;
};

export { renderTextVariations };
